import * as React from 'react';
import {  Dimensions } from "react-native";

const screenWidth = Dimensions.get("window").width;

const screenHeight = Dimensions.get("window").height;

const TradeView = ({idCoin}) => {

    return (
        <iframe src={'https://api.gpxexchange.com.br/tradeview/'+ idCoin} style={{ 
            width: screenWidth, height: screenHeight*0.5, padding: 0, margin: '0 auto'
        }}>
        </iframe>
    );

}


export default TradeView;